import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from '@narvar/moment-shim';
import { SemibigHeader, MediumHeader } from '@narvar/nth-header';

const mapStateToProps = ({
  language: { 'returns.pickups_page.tomorrow': tomorrowLabel },
  retailerSettings: { branding: { brand_call_to_action: brandCTAColor } = {} } = {},
}) => ({
  tomorrowLabel,
  brandCTAColor,
});

const PickupDate = ({ tomorrowLabel, date, brandCTAColor, size }) => {
  const momentDate = moment(date);

  const isAvailableTomorrow = moment().add(1, 'day').isSame(momentDate, 'day');
  const shortDate = momentDate.format('MMMM D');
  const dateDisplay = isAvailableTomorrow ? `${tomorrowLabel}${shortDate}` : `${shortDate}`;

  const Header = size === 'medium' ? MediumHeader : SemibigHeader;
  return <Header s={{ color: brandCTAColor, margin: '1rem auto' }}>{dateDisplay}</Header>;
};

PickupDate.defaultProps = {
  brandCTAColor: '#000000',
  size: 'semibig',
};

PickupDate.propTypes = {
  date: PropTypes.string.isRequired,
  tomorrowLabel: PropTypes.string.isRequired,
  brandCTAColor: PropTypes.string,
  size: PropTypes.string,
};

export default connect(mapStateToProps)(PickupDate);
